import { Controller } from "@hotwired/stimulus"

// 폼 자동 제출 컨트롤러
// select 변경 시 자동으로 폼 제출
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
